import React from 'react';
import {makeStyles} from "@mui/styles";
import Rocket from "./assets/rocket.png"
import {AppButton} from "../ui/AppButton";
import {useHistory} from "react-router";
import {Routes} from "../../constants/Routes";
import {useI18n} from "../../i18n/I18nContext";

const useStyles = makeStyles(() => ({
    root: {
        background: "#fff",
        boxShadow: "0px 14px 24px #C6C8D7",
        borderRadius: 16,
        display: "flex",
        padding: 24
    },
    formRoot: {
        flex: "1 1",
        height: "100%",
        "& h3": {
            fontWeight: 700,
            fontSize: 18,
            marginBottom: 20,
        },
        "& p": {
            fontSize: 16,
            marginBottom: 16,
            color: "#757575"
        }
    },
    imgRoot: {
        "@media (max-width: 554px)": {
            display: "none",
        }
    }
}));

export function IntegrationsCreateBanner() {
    const classes= useStyles();
    const history = useHistory();
    const {translate} = useI18n();
    return (
        <div className={classes.root}>
            <div className={classes.formRoot}>
                <h3>{translate("BUILD_INTEGRATION_TITLE")}</h3>
                <p>{translate("BUILD_INTEGRATION_DESCRIPTION")}</p>
                <AppButton onClick={() => history.replace({pathname: Routes.IntegrationCreate})}>
                    {translate("START_INTEGRATION")}
                </AppButton>
            </div>
            <div className={classes.imgRoot}>
                <img src={Rocket} alt="rocket"/>
            </div>
        </div>
    );
}

